import React, { useCallback, useEffect } from 'react';
import './Header.scss';
import { MenuProps, Row, Spin } from 'antd';
import { Button } from '@turing/components/Button';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setShowSchedule } from 'store/features/event-slice';
import { Dropdown } from '../Dropdown';

export const Header = () => {
  const dispatch = useAppDispatch();
  const eventsLoading = useAppSelector(state => state.event.loading);
  const liveEvents = useAppSelector(state => state.event.liveEvents);
  const showSchedule = useAppSelector(state => state.event.showSchedule);

  const handleWindowResize = useCallback(
    (event: Event) => {
      const target = event.target as Window;
      if (target.innerWidth > 767 && showSchedule) {
        dispatch(setShowSchedule(false));
      }
    },
    [dispatch, showSchedule],
  );

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [handleWindowResize]);

  const liveEventsItems: MenuProps['items'] = liveEvents.map(event => {
    return {
      key: event.id,
      label: (
        <a target="_blank" rel="noopener noreferrer" href={event.url}>
          {event.summary}
        </a>
      ),
    };
  });

  return (
    <Row justify={'space-between'} align={'middle'} className="header-wrapper">
      <div className="left-wrapper">
        {eventsLoading && (
          <>
            <Spin />
            <span className="loading-text">Loading...</span>
          </>
        )}
        <Button
          onClick={() => dispatch(setShowSchedule(!showSchedule))}
          className={`calendar-button ${showSchedule && 'show'}`}
          type="ghost"
          icon={<img src="calendar.png" alt="Girl in a jacket" width="20" height="20" />}
        />
      </div>
      {liveEvents.length === 1 ? (
        <Button
          href={liveEvents[0].url}
          target="_blank"
          text={`${liveEvents[0].summary} at ${new Date(liveEvents[0].start).toLocaleTimeString().substring(0, 5)}`}
        />
      ) : liveEvents.length > 1 ? (
        <Dropdown items={liveEventsItems} text={`Live events: ${liveEvents.length}`} />
      ) : (
        <></>
      )}
    </Row>
  );
};
